// extracted by mini-css-extract-plugin
export default {"main":"UserPage_main__YqnZC","pagos":"UserPage_pagos__IbzxX","filtros":"UserPage_filtros__beoeH","filtrosSub":"UserPage_filtrosSub__5KLge"};